var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.63 80.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1133.65,
    y1: 2140.65,
    x2: -1056.05,
    y2: 2073.88,
    gradientTransform: "translate(636.28 1218.61) scale(.56 -.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b86f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#386aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1948",
    className: "cls-2",
    d: "M39.59,.5c-3.26,.02-6.38,.29-9.12,.78-8.08,1.43-9.54,4.41-9.54,9.92v7.27h19.09v2.42H13.77c-5.55,0-10.4,3.33-11.92,9.68C.09,37.84,.01,42.38,1.84,49.97c1.36,5.65,4.6,9.68,10.14,9.68h6.56v-8.72c0-6.3,5.45-11.86,11.92-11.86h19.06c5.31,0,9.54-4.37,9.54-9.7V11.2c0-5.17-4.36-9.06-9.54-9.92-3.28-.55-6.68-.79-9.94-.78Zm-10.32,5.85c1.97,0,3.58,1.64,3.58,3.65,0,2-1.61,3.63-3.58,3.63-1.98,0-3.58-1.62-3.58-3.63s1.6-3.65,3.58-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1950",
    className: "cls-1",
    d: "M61.46,20.9v8.48c0,6.57-5.57,12.1-11.92,12.1H30.47c-5.22,0-9.54,4.47-9.54,9.7v18.17c0,5.17,4.5,8.21,9.54,9.7,6.04,1.78,11.83,2.1,19.06,0,4.8-1.39,9.54-4.19,9.54-9.7v-7.27h-19.06v-2.42h28.61c5.55,0,7.61-3.87,9.54-9.68,1.99-5.98,1.91-11.73,0-19.4-1.37-5.52-3.99-9.68-9.54-9.68h-7.16Zm-10.72,46.02c1.98,0,3.58,1.62,3.58,3.63s-1.6,3.65-3.58,3.65-3.58-1.64-3.58-3.65,1.61-3.63,3.58-3.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.cd59ee681038dd5927b10be69f9fbcb7.svg";
export { ForwardRef as ReactComponent };